import React from 'react';
import BasicInfoCard from 'components/ItemInfoCard/BasicInfoCard';
import messages from 'components/ItemInfoCard/messages';
import { translate } from 'helpers/intl';
import { injectIntl } from 'react-intl';
import {
  SanteInternationalInfoCardProps,
  styles,
} from 'components/ItemInfoCard/types';
import { makeStyles } from '@material-ui/core';
import MyContractBackground from 'images/BG-assurance-maladie.svg';
const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    width: '83px !important',
    borderRadius: '6px',
    color: '#172C51 !important',
    border: '1px solid #FFFFFF !important',
    '&:hover': {
      color: '#285BC7 !important',
    },
  },
});
const SanteInternational = (props: SanteInternationalInfoCardProps) => {
  const {
    Key1Value,
    Key2Value,
    title = 'Produit STANDARD',
    wrapperPaddingLeft,
    wrapperPaddingRight,
  } = props;
  const classes = useStyles();
  const styles: styles = {
    icon: 'HEALTHMainIcon',
    titleColor: '#FFEC01',
    labelsColor: 'rgba(255,255,255,0.87)',
    valuesColor: '#FFF',
    backgroundImage: MyContractBackground,
    buttonRootStyles: classes.root,
  };
  return (
    <BasicInfoCard
      styles={styles}
      Key1Label={translate(messages.indetifiant, props)}
      Key1Value={Key1Value}
      Key2Label={translate(messages.numPolice, props)}
      Key2Value={Key2Value}
      title={title}
      wrapperPaddingLeft={wrapperPaddingLeft}
      wrapperPaddingRight={wrapperPaddingRight}
      buttonLabel={translate(messages.voirTous, props)}
      redirectionPath="/autoDetails"
    />
  );
};

export default injectIntl(SanteInternational);
